import { media } from "@features/adaptive/breakpoints";
import { Typography } from "@packages/uiKit";
import Image from "next/image";
import styled, { css } from "styled-components";

export const StyledMissionValues = styled.div`
  display: flex;
  flex-direction: column;
  gap: 127px;

  ${media.down("tablet")} {
    gap: 84px;
  }
`;

export const StyledImage = styled(Image).attrs({ width: 500, height: 500 })`
  width: 100%;
  height: auto;
  object-fit: contain;
`;

export const StyledContentRow = styled.div<{
  reverse?: boolean;
}>`
  display: grid;

  row-gap: 30px;
  column-gap: 90px;

  grid-template-columns: 1fr 1fr;

  ${({ reverse }) =>
    reverse
      ? css`
          grid-template-areas:
            "image title"
            "image description";
        `
      : css`
          grid-template-areas:
            "title image"
            "description image";
        `}

  ${media.down("tablet")} {
    grid-template-columns: 1fr;
    grid-template-areas:
      "image"
      "title"
      "description";
    gap: 0;
  }
`;

export const StyledTitle = styled(Typography).attrs({
  size: 38,
  weight: 400,
  color: "dark",
})`
  ${media.down("tablet")} {
    font-size: 28px;
    margin-bottom: 15px;
  }
  grid-area: title;
`;

export const StyledDescription = styled(Typography).attrs({
  size: 20,
  weight: 400,
  color: "dark",
})`
  ${media.down("tablet")} {
    font-size: 18px;
  }
  grid-area: description;
`;

export const StyledImageContainer = styled.div`
  align-self: center;
  grid-area: image;
  height: 260px;

  ${media.down("tablet")} {
    margin-bottom: 37px;
    height: auto;
  }
`;
